/**
 * @generated SignedSource<<9198a6ef49bb49e37255f2069455d92d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSellerItemTileCarousel_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItem_user">;
  readonly " $fragmentType": "PdpRespSellerItemTileCarousel_user";
};
export type PdpRespSellerItemTileCarousel_user$key = {
  readonly " $data"?: PdpRespSellerItemTileCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSellerItemTileCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSellerItemTileCarousel_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItem_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "9e3e40a7b446dcb94fffb63d729acd30";

export default node;
